@let dtgsValue = dtgs();
@let dtgIndexValue = dtgIndex();
@let regionValue = region();
@let radarProjectionValue = getRadarProjection(regionValue);
@let radarTileUrlsValue = radarTileUrls();

@if (dtgsValue?.[dtgIndexValue]) {
  <mgl-control position="top-left">
    <div
      [ngClass]="
        dtgsValue[dtgIndexValue].isFcst
          ? 'dtg-control dtg-fcst'
          : dtgsValue[dtgIndexValue].isArchive
            ? 'dtg-control'
            : 'dtg-control dtg-obs'
      ">
      {{ dtgsValue[dtgIndexValue].info }}
    </div>
  </mgl-control>
}

@if (radarProjectionValue) {
  @for (dtg of dtgsValue; track $index; let i = $index) {
    @let radarTileUrlValue = radarTileUrlsValue[i];

    @if (radarTileUrlValue) {
      <mgl-raster-source
        [id]="'radar' + i"
        [tiles]="[radarTileUrlValue]"
        [tileSize]="1024"
        [bounds]="radarProjectionValue"
        [maxzoom]="4">
      </mgl-raster-source>

      <mgl-layer
        [id]="'radar' + i"
        [source]="'radar' + i"
        type="raster"
        [paint]="
          $any(dtg.visible ? radarPaintVisible() : radarPaintInvisible())
        ">
      </mgl-layer>
    }
  }
}
